(ns kyber.styles.overlays
  (:require [goog.color :as c]))

(defn- hex->rgba
  [hex opacity]
  (let [[r g b] (c/hexToRgb hex)]
    (str "rgba(" r "," g "," b "," opacity ")")))

(defn overlay
  [colors]
  {:white (str "linear-gradient(to top left, "
               "rgba(234,234,234,0.80), "
               "rgba(251,251,251,0.60))")

   :gray (str "linear-gradient(to top left, "
              "rgba(97,97,97,0.85), "
              "rgba(47,47,47,0.85))")

   :gray-opacity-50 (str "linear-gradient(to top left, "
                         "rgba(97,97,97,0.5), "
                         "rgba(47,47,47,0.5))")

   :gray-opacity-75 (str "linear-gradient(to top left, "
                         "rgba(97,97,97,0.75), "
                         "rgba(47,47,47,0.75))")

   :blue (str "linear-gradient(to top left, "
              "rgba(11,39,79,0.85), "
              "rgba(0,90,150,0.85))")

   :green (str "linear-gradient(to bottom right, "
               "rgba(123,166,59,1), "
               "rgba(161,193,108,1))")

   :orange (str "linear-gradient(to bottom right, "
                "rgba(209,130,63,1), "
                "rgba(245,183,120,1))")

   :partner (str "linear-gradient(to top left, "
                 (:primary-lite-600 colors) ", "
                 (:primary-lite-400 colors) ")")

   :partner-opacity-70 (str "linear-gradient(to bottom right, "
                            (hex->rgba (:primary-lite-600 colors) "0.7") ", "
                            (hex->rgba (:primary-lite-400 colors) "0.7") ")")
   :partner-opacity-85 (str "linear-gradient(to bottom right, "
                            (hex->rgba (:primary-lite-600 colors) "0.85") ", "
                            (hex->rgba (:primary-lite-500 colors) "0.85") ")")})
